import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    textFieldRoot: {
        width: '100%',
        marginBottom:'20px',
        '& .MuiFormLabel-root': {
            color: '#ED6628',
        },
        '& .MuiFormLabel-root.Mui-focused': {
            color: '#ED6628',
        },
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#fff',
            width: '100%',
        },
    },
    popupTitle: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        marginBottom: '10px !important',
        marginTop: '20px',
        fontSize: '35px !important',
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    assessTitle: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '37px !important',
        marginTop:'30px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    ReportTitle: {
        // color: '#000000',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    status: {
        color: '#ED6628',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '30px !important',
    },
    loader:{
        color: "#E7466E !important",
    },
    ratingStar:{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 2,
    },
    fileUploadContainer:{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: "700px",
        marginTop:'20px',
        position: "relative",
    },
    // styles for Rating Content Report Page
    cardsContainer:{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: '90px',
        flexWrap: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
        },
    },
    cardTitle:{
        fontWeight: "bold",
        marginBottom: 2,
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        minHeight:'90px',
    },
    badgeButton: {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        alignSelf: 'center',
        padding:'10px 30px !important',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },
    },
    actionButton: {
        borderRadius: '13px',
        fontSize: '20px',
        padding: '6px 32px',
        marginRight: theme.spacing(1),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        }, [theme.breakpoints.down('sm')]: {
            marginBottom:'15px',
            width:'100%',
            borderRadius: '13px',
        },
        '&.Mui-disabled': {
            background: '#e0e0e0 !important',
            color: '#9e9e9e !important',
            borderColor: '#bdbdbd !important',
        },
    },

    Button: {
        borderRadius: '13px',
        fontSize: '20px',
        padding: '6px 32px',
        marginRight: theme.spacing(1),
        color: '#fff',
        '&:hover': {
        }, [theme.breakpoints.down('sm')]: {
            marginBottom:'15px',
            width:'100%',
            borderRadius: '13px',
        },
        '&.Mui-disabled': {
            background: '#e0e0e0 !important',
            color: '#9e9e9e !important',
            borderColor: '#bdbdbd !important',
        },
    },

// Company Info styles
    infoTitle: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize:'24px !important',
        },
    },
    formLabel: {
    color: '#ED6628 !important',
    },
    container: {
        padding: theme.spacing(3),
        marginTop: '12px',
    },
    formControl: {
        marginBottom: theme.spacing(2),
        minWidth: '100%',
    },
// Program Info styles

    programContainer: {
        padding: theme.spacing(3),
        marginTop: '12px',
        marginBottom: theme.spacing(2),
    },
    section: {
        marginBottom: theme.spacing(4),
    },
    instruction: {
        margin: theme.spacing(3,3,3,0),
    },

    // Select program assessment
    disabledField: {
        '& .MuiOutlinedInput-root.Mui-disabled': {
            color: 'inherit',
            background: 'white',
            border: `1px solid ${theme.palette.divider}`,
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'inherit',
            },
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75)',
        },
    },
    assessmentButton: {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        alignSelf: 'center',
        width:'150px',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },
    },
    assessmentContainer: {
        padding: theme.spacing(1),
        textAlign:'center',
        width:'100%',
    },
    paper: {
        position: 'absolute',
        width: '80%',
        maxHeight: '80%',
        overflowY: 'auto',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    assessmentInstruction: {
        margin: theme.spacing(2, 3, 2, 0),
    },
    button: {
        width: '15%',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1, 3, 1, 3),
        fontSize: '20px',
        border: 'none',
        borderRadius: '5px',
        margin:theme.spacing(2),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },
        [theme.breakpoints.down('sm')]: {
          padding:'10px 60px'
        },

    },
    confirmButton:{
        backgroundColor: '#EE6628',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#D45A24'
        },
        minWidth: '120px',
        textTransform: 'none',
        fontWeight: 'bold',
    },
    cancelButton:{
        color: '#EE6628',
        borderColor: '#EE6628',
        backgroundColor: '#fff',
        '&:hover': {
            borderColor: '#EE6628',
            backgroundColor: 'rgba(238, 102, 40, 0.04)'
        },
        minWidth: '120px',
        textTransform: 'none',
        fontWeight: 'bold',
    },
    mt: {
        marginTop: theme.spacing(2),
    },
    mb: {
        marginBottom: theme.spacing(2),
    },
    listItem: {
        paddingLeft: theme.spacing(7),
        position: 'relative',
    },
    bullet: {
        content: '""',
        position: 'absolute',
        left: theme.spacing(4),
        top: '50%',
        transform: 'translateY(-50%)',
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        color:'black',
    },
    card: {
        textAlign: 'justify',
        width: '20vw',
        margin:'20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: "#ffff",
        borderRadius: "30px",
        // boxShadow: "6px 0px 20px rgba(0, 0, 0, 0.3)",
        flex: '1 0 auto',
        '&:not(:last-child)': {
            marginRight: 0,
        },
        height:'380px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            margin:'20px 0px',
        },
    },
    cardContent:{
        padding:'0px !important',
    },
    assessmentCard: {
        textAlign: 'justify',
        margin:'14px',
        border:'1px solid #052F44',
        backgroundColor: "#F4F4F4",
        borderRadius: "12px",
        width: "100%",
        [theme.breakpoints.down('sm')]: {
            width: 'auto',
        },
    },
    verticalDivider: {
        borderRight: `2px solid lightgrey`,
        height: '455px',
        margin:'0 1%',
    },
    nestedCard: {
        borderRadius: theme.spacing(1),
        border: `2px solid black`,
        boxShadow: 'none',
        height: '19vh',
        margin:theme.spacing(1),
    },
    nestedCardContainer: {
        display: 'flex',
        textAlign:'center',
        justifyContent:'center',
        alignItems:'center',
        marginBottom:'17px',
    },
    nestedButton:{
        width:'90%',
        padding: theme.spacing(1, 2, 1, 2),
        height:'200px',
        backgroundColor: theme.palette.background.paper,
        fontSize: '14px',
        color: "black",
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: '15px',
        margin:theme.spacing(1),
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '50vw',
        margin: '0 auto',
        marginTop: theme.spacing(2),
        textAlign:'left',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '90%',
        },
    },
    textField: {
        marginBottom: theme.spacing(1),
    },
    mySpan: {
        display: 'block',
    },
    sectionContainer:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        padding: "34px 140px",
        [theme.breakpoints.down('sm')]: {
            padding:'0px !important',
            flexDirection:'column',
        },
    },
    sectionItem:{
        backgroundColor: "white",
        flex: 1,
        paddingBottom:'50px',
        margin:'0 25px',
        boxShadow: "6px 0px 20px rgba(0, 0, 0, 0.3)",
        borderRadius:'35px',
        position:'relative',
        [theme.breakpoints.down('sm')]: {
            margin:'20px 25px',
        },
    },
    label: {
        textAlign: 'left',
        marginRight: theme.spacing(2),
        paddingLeft: '15px !important',
    },
    value: {
        marginTop: theme.spacing(0.5),
        marginLeft: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign:'left',
    },
    assessmentTitle: {
        marginBottom:'10px',
        color: theme.palette.text.secondary,
        paddingLeft: '15px !important',
        display: 'flex',
        alignItems: 'flex-end',
    },
    button1: {
        '&:hover': {
            backgroundColor: '#41BAE4',
            color:'white',
        },
    },
    activeButton1: {
        backgroundColor: '#41BAE4',
        color:'white',
    },
    button2: {
        '&:hover': {
            backgroundColor: '#6D8DC8',
            color:'white',
        },
    },
    activeButton2: {
        backgroundColor: '#6D8DC8',
        color:'white',
    },
    button3: {
        '&:hover': {
            backgroundColor: '#E4428E',
            color:'white',
        },
    },
    activeButton3: {
        backgroundColor: '#E4428E',
        color:'white',
    },
    button4: {
        '&:hover': {
            backgroundColor: '#D60464',
            color:'white',
        },
    },
    activeButton4: {
        backgroundColor: '#D60464',
        color:'white',
    },
    button5: {
        '&:hover': {
            backgroundColor: '#E66027',
            color: 'white',

        },
    },
    activeButton5: {
        backgroundColor: '#E66027',
        color: 'white',
    },
    cardHeader:{
        width: '100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'flex-start',
        paddingTop:'20px',
        height: '200px',
        background: 'linear-gradient(to bottom right, #6A8EC9 0%, #8C74A7 30%, #D44C71 66%, #C91C6E 103%)',
        borderBottomLeftRadius: '100% 50px',
        borderBottomRightRadius: '100% 50px',
        overflow: 'hidden',
        position: 'relative',
    },

// Rating Access Assessment styles

    accessAssessmentContainer: {
        padding: theme.spacing(4),
        textAlign:'center',
    },
    accessAssessmentButton: {
        borderRadius:'15px',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1, 3, 1, 3),
        fontSize: '14px',
        border: 'none',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%)",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%)",
            color: '#fff',
        },
        '&.Mui-disabled': {
            background: '#e0e0e0 !important',
            color: '#9e9e9e !important',
            borderColor: '#bdbdbd !important',
        }
    },
    paperStyle: {
        padding: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'left',
        textAlign: 'left',
        height:'100%',
    },
    listItemStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
    },
    customButton: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.background.default,
        '&:hover': {
            backgroundColor: theme.palette.error.main,
        },
    },
    customButton2: {
        backgroundColor: '#0097a7',
        color: 'white',
        padding:'15px 50px !important',
        lineHeight:'1.1 !important',
        fontSize:'18px !important',
        marginBottom:'55px',
        fontWeight:'normal !important',
        '&:hover': {
            cursor:'pointer',
            backgroundColor:'#0097a7 !important',
            color:'#fff !important',
        },
    },
    dialogButton:{
        backgroundColor:'#ff6468ff !important',
        color:'#fff !important',
        padding:'15px 50px !important',
        lineHeight:'1.1 !important',
        fontSize:'18px !important',
        marginBottom:'55px',
        fontWeight:'normal !important',
        '&:hover': {
            cursor:'pointer',
            backgroundColor:'#ff6468ff !important',
            color:'#fff !important',
        },
    },
}));
export default useStyles;